<template>
    <div class="SRWrapper results">
        <router-link
            v-if="item.route"
            :to="item.route"
            class="results-item"
            @click.native="$emit('navigate')"
        >
            <SearchHighlight
                class="results-title"
                :search="search"
                :text="item.title"
                :stringLength="90"
                v-if="item.title"
            />
            <SearchHighlight
                class="results-text"
                :search="search"
                :text="item.text"
                :stringLength="160"
                v-if="item.text"
            />
            <div class="results-meta">
                <span class="results-partition">{{ getField(item) }}</span>
                <span class="results-date" v-if="item.date">{{ getDate(item) }}</span>
            </div>
        </router-link>
        <a
            v-else
            :href="link"
            class="results-item"
            @click="$emit('navigate')"
        >
            <SearchHighlight
                class="results-title"
                :search="search"
                :text="item.title"
                :stringLength="90"
                v-if="item.title"
            />
            <SearchHighlight
                class="results-text"
                :search="search"
                :text="item.text"
                :stringLength="160"
                v-if="item.text"
            />
            <div class="results-meta">
                <span class="results-partition">{{ getField(item) }}</span>
                <span class="results-date" v-if="item.date">{{ getDate(item) }}</span>
            </div>
        </a>

    </div>
</template>

<script>
import SearchHighlight from './SearchHighlight';
import { getFormattedDate } from '@/tools/moment-date';

export default {
    name: "SearchResult",
    components: {
        SearchHighlight,
    },
    data: () => ({
    }),
    props: {
        search: {
            type: String,
            default: '',
        },
        item: {
            type: Object,
        },
    },
    computed: {
        link() {
            if (this.item.link) {
                return this.item.link(window.rsvDomain);
            } else return '#';
        },
    },
    methods: {
        getField(item) {
            const affiliation = item ? item.affiliation : '';
            if (!affiliation) {
                return '';
            }
            const relations = {
                progress_soft_skills: 'Компетенции',
                projects_spk2: 'Проекты',
                contests: 'Конкурсы',
                competitions: 'Проекты',
                course: 'Курсы',
                internship: 'Проекты',
                news: 'Новости',
                testing: 'Тесты',
                success_story: 'Истории успеха',
                gallery: 'Фотогалерея',
                blogs: 'Блог',
                mentoring: 'Наставничество',
                page: 'О нас',
            };

            const field = relations[affiliation];

            return field ? field : 'Общее';
        },

        getDate(item) {
            return item.date ? getFormattedDate(item.date, 'DD.MM.YYYY') : '';
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../styles/rem";

    .results {
        &-item {
            display: block;
            margin-top: rem(16);
            padding-bottom: rem(16);
            border-bottom: 1px solid #D2D5D9;

            @include on-md {
                margin-top: 0;
                padding-bottom: mdrem(16);
            }

            @include on-mobile {
                margin-top: 0;
                padding-bottom: mrem(16);
            }

        }

        &-title {
            margin-bottom: rem(12);
            font-weight: 600;
            font-size: rem(20);
            line-height: rem(28);
            color: #2A2626;

            @include on-md {
                margin-bottom: mdrem(8);
                font-size: mdrem(18);
                line-height: mdrem(26);
            }

            @include on-mobile {
                margin-bottom: mrem(8);
                font-size: mrem(18);
                line-height: mrem(26);
            }
        }

        &-text {
            margin-bottom: rem(10);
            font-size: rem(16);
            line-height: rem(24);
            color: #2A2626;

            @include on-md {
                margin-bottom: mrem(8);
                font-size: mdrem(15);
                line-height: mdrem(22);
            }

            @include on-mobile {
                margin-bottom: mrem(8);
                font-size: mrem(15);
                line-height: mrem(22);
            }
        }

        &-meta {
            font-size: rem(15);
            line-height: rem(22);
            text-transform: uppercase;
            color: #98A0A9;

            @include on-md {
                font-size: mdrem(15);
                line-height: mdrem(22);
            }

            @include on-mobile {
                font-size: mrem(15);
                line-height: mrem(22);
            }
        }

        &-date {
            margin-left: rem(8);

            @include on-mobile {
                margin-left: mrem(8);
            }
        }
    }
</style>
